import React, { Component } from 'react';
import { HttpRequestService } from '../../services/HttpRequestService';
import moment from 'moment'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { UtilsService } from '../../services/UtilsService';
import { UserService } from '../../services/UserService';
import Report from '../../common/Report';
import SalesmanSelect from '../../common/SalesmanSelect';

class DailyCallsReport extends Component {

    constructor(props) {
        super(props);
        this.utils = new UtilsService();
        var initialState = {
            beginDate: moment().subtract(7, 'day').toDate(),
            endDate: moment(new Date()).toDate(),
            enteredBy: "",
            report: null,
        }
        this.paramsKey = "params.daily-calls-report";
        this.state = this.utils.prepareSessionState(initialState, this.paramsKey);

        this.http = new HttpRequestService();
        this.handleBeginDateChange = this.handleBeginDateChange.bind(this);
        this.handleEndDateChange = this.handleEndDateChange.bind(this);
        this.handleRepChange = this.handleRepChange.bind(this);
        this.getReport = this.getReport.bind(this);
    }

    componentDidMount() {
        this.getReport();
    }

    handleBeginDateChange(e) {
        this.setState({ beginDate: e });
    }

    handleEndDateChange(e) {
        this.setState({ endDate: e });
    }

    handleRepChange(user) {
        this.setState({ enteredBy: user.initials });
    }

    getReport(e) {
        if (!!e) {
            e.preventDefault();
        }
        var params = {
            beginDate: this.state.beginDate != null ? moment(this.state.beginDate).format('L') : "",
            endDate: this.state.endDate != null ? moment(this.state.endDate).format('L') : "",
            enteredBy: this.state.enteredBy,
        }

        sessionStorage.setItem(this.paramsKey, JSON.stringify(params));

        this.http.get('/api/Report/GetDailyCallsReport', params).then(data => {
            this.setState({ report: data });
        });
    }

    render() {
        return (
            <div className="page-inner">
                <div className="page-header">
                    <h4 className="page-title">Daily Calls Report</h4>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-body">
                                <form onSubmit={this.getReport}>
                                    <div className="form-row">
                                        <div className="form-group col-md-3">
                                            <label htmlFor="beginDate">Start Date</label>
                                            <DatePicker className="form-control" selected={this.state.beginDate} onChange={this.handleBeginDateChange} />
                                        </div>
                                        <div className="form-group col-md-3">
                                            <label htmlFor="endDate">End Date</label>
                                            <DatePicker className="form-control" selected={this.state.endDate} onChange={this.handleEndDateChange} />
                                        </div>
                                        {!UserService.IsUserInRole("Field Rep") &&
                                            <div className="form-group col-md-3">
                                                <label>Sales Rep</label>
                                                <SalesmanSelect value={this.state.enteredBy} onChange={this.handleRepChange} hasAllOption={true}></SalesmanSelect>
                                            </div>
                                        }
                                    </div>
                                    <div className="form-row justify-content-end">
                                        <button type="submit" className="btn btn-primary">Submit</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                        {this.state.report != null &&
                            <Report name="DailyCallsReport" hasData={this.state.report.summaryItems && this.state.report.summaryItems.length > 0} title="Daily Calls Report">
                                <div className="form-row">
                                    <table className="table table-striped mt-1 report-table">
                                        <thead>
                                            <tr>
                                                <th scope="col">TERRITORY</th>
                                                <th className="currency" scope="col">DENTAL CALLS/DAY</th>
                                                <th className="currency" scope="col">HCP CALLS/DAY</th>
                                                <th className="currency" scope="col">CALLS/DAY</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.report.summaryItems.map((item, i) =>
                                                <tr key={i}>
                                                    <td>{item.territory}</td>
                                                    <td className="currency">{item.dentalCallsPerDay}</td>
                                                    <td className="currency">{item.nonDentalCallsPerDay}</td>
                                                    <td className="currency">{item.callsPerDay}</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </Report>
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default DailyCallsReport;
